export const HAS_NOTIFICATIONS_SIDEBAR_BREAKPOINTS = [
  {
    mq: '(max-width: 459px)',
    value: 'XS',
  },
  {
    mq: '(min-width: 460px) and (max-width: 767px)',
    value: 'S',
  },
  {
    mq: '(min-width: 768px) and (max-width: 1200px)',
    value: 'M',
  },
  {
    mq: '(min-width: 1201px)',
    value: 'L',
  },
];
